<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">动环设备</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="设备名称" prop="DeviceName">
            <el-input
              v-model="DeviceName"
              placeholder="请输入设备名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="区域">
            <el-select v-model="RegionId" placeholder="请选择">
              <el-option key="" label="全部" value="null"></el-option>
              <el-option
                v-for="item in RegionData"
                :key="item.RegionId"
                :label="item.RegionName"
                :value="item.RegionId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否在线">
            <el-select v-model="IsOnline" placeholder="请选择">
              <el-option key="" label="全部" value="null"></el-option>
              <el-option key="" label="在线" value="true"></el-option>
              <el-option key="" label="离线" value="false"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="" class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div
            class="zj-table-container"
          >
            <el-table
              v-loading="searching"
              element-loading-text="搜索中"
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
            <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column
                prop="DeviceName"
                label="设备名称"
              ></el-table-column>
              <el-table-column prop="RegionName" label="区域">
              </el-table-column>
              <el-table-column prop="Longitude" label="经度" width="140">
              </el-table-column>
              <el-table-column prop="Latitude" label="纬度" width="140">
              </el-table-column>
              <el-table-column prop="IsOnline" label="状态" width="140">
                <template slot-scope="scope">
                  <span v-if="scope.row.IsOnline == false" style="color: red"
                    >离线</span
                  >
                  <span v-if="scope.row.IsOnline == true">在线</span>
                </template>
              </el-table-column>
              <!-- fixed="right"  -->
              <el-table-column label="操作" width="160">
                <template slot-scope="scope">
                  <el-button
                    @click="handleClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >查看</el-button
                  >
                  <el-button
                    @click="editClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >编辑</el-button
                  >
                  <el-button
                    @click="deleteClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>
<script>
import MyApis from "../../../../../equipment/src/apis";


export default {
  name: "DynamicEnvEquipView",
  controller: "UI",
  action: "DynamicEnvEquipView",
  data() {
    return {
      searching: false, // 搜索中...
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      RegionData: [],
      EquipmentType: "DynamicEnvironment", //设备类型
      DeviceId: null,
      DeviceName: null, //设备名称
      RegionId: null, //地区ID
      area: "",
      IsOnline: null, //在线是否
      DeviceType: null,
      DeviceTypesArr: [], //设备类型的数组值

     
  
    };
  },
  created() {
    this.getType();
    this.basedataRegion();
  },
  mounted() {
    this.search();
    this.logInfo.ActionName = "动环设备查询";
    this.logInfo.LogMessage = "动环设备查询";
    this.logInfo.ModuleName = "动环监测";
    this.logInfo.PageName = "动环设备管理列表";
    this.addOperationLog();
  },
  methods: {
    getDevicetypeShow(row, column) {
      let that = this;
      let data = row[column.property];
      if (data) {
        let arr = that.DeviceTypesArr;
        let result = "";
        arr.forEach((item) => {
          if (item.ItemKey == data) {
            result = item.Description;
          }
        });
        return result;
      }
    },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    // 表格的选中 可以获得当前选中的数据
    selectionChange(val) {
      // 将选中的数据存储起来
      this.selectData = val;
    },
    search() {
      this.searching = true;
      let online = null;
      if (this.IsOnline == "true") {
        online = true;
      } else if (this.IsOnline == "false") {
        online = false;
      }
      let lookRegionId = this.RegionId;
      if (this.RegionId == "null") {
        lookRegionId = null;
      }
    
      let searchInfo = {
        EquipmentType: "DynamicEnvironment", //设备类型
        DeviceId: this.DeviceId,
        DeviceName: this.DeviceName, //设备名称
        DeviceType: "SubSystem.DynamicEnvironment",
        DeviceTypes: [],
        RegionId: lookRegionId, //地区ID
        IsOnline: online, //在线是否
        ScenicId: null, //景区ID
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
      };
      new MyApis.MonitorApi()
        .GetEquipmentPagingList(searchInfo)
        .then((r) => {
          //console.log("1");
          this.searching = false;
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
        })
        .catch((e) => {
          console.log(e);
          this.searching = false;
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    clearsearch() {
      this.EquipmentType = null; //设备类型
      this.DeviceId = null;
      this.DeviceName = null; //设备名称

      this.RegionId = null; //地区ID
      this.IsOnline = null; //在线是否
      this.search();
    },
    basedataRegion() {
      let searchInfo = {
        EquipmentType: "Monitor",
        Longitude: 0.0,
        Latitude: 0.0,
      };
      new MyApis.RegionApi()
        .GetRegionInfos(searchInfo)
        .then((r) => {
          console.log("区域");
          console.log(r);
          this.RegionData = r.data.Data;
          this.localRegions = r.data.Data.map((x) => {
            return x.RegionId;
          });
          this.defaultRegion = r.data.Data.find((x) => {
            if (x.RegionName == "其他" || x.RegionName == "其它") {
              return x;
            }
          });
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
    },
   
    //编辑按钮
    editClick(index, row) {
      this.$router.push({
        path: "/plugin/dynEnvironment/UI/DynamicEnvEquipInfo",
        query: {
          DeviceId: row.DeviceId,
          type: "edit",
        },
      });
    },
    //查看详细
    handleClick(index, row) {
      console.log(index);
      console.log(row);
      this.$router.push({
        path: "/plugin/dynEnvironment/UI/DynamicEnvEquipInfo",
        // name: 'mallList',
        query: {
          DeviceId: row.DeviceId,
          type: "look",
        },
      });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/dynEnvironment/UI/DynamicEnvEquipInfo",
        query: {
          type: "add",
        },
      });
    },
  
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          new MyApis.MonitorApi()
            .DelEquipment(row)
            .then((r) => {
              r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.logInfo.ActionName = "动环设备删除";
                this.logInfo.LogMessage = "动环设备删除";
                this.logInfo.ModuleName = "动环监测";
                this.logInfo.PageName = "动环设备管理列表";
                this.addOperationLog();
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!",
                });
              }
              this.search();
            })
            .catch((e) => {
              console.log(e);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    ConvertTranresourcesType(row, column) {
      let data = row[column.property];
      if (data == null) {
        return null;
      }
      let levelstr = this.TranresourcesTypeDic[data];
      return levelstr;
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
    getType() {
      let that = this;
      this.config
        .getUValue(":Monitor.DeviceTypes", "")
        .then((d) => {
          console.log(d);
          that.DeviceTypesArr = d.JValue;
        })
        .catch((e) => console.error(e));
    },
  },
};
</script>
